import moment from 'moment';
import { CustomSelect } from '../../../../UsersList/components/CustomSelect';
import { PlansCombobox, RecruitersCombobox } from '../../../components';
import { JobStatus, jobStatusOptions } from '../../../shared/constants';
import { FormCard } from '../../../shared/FormCard';
import { RouteLink } from '../../../../../commonComponents/RouteLink';
import { InfoRow } from '../../../shared/InfoRow';

export const JobDetailsCard = ({ job, handleRecruiterChange, handleJobStatusChange }) => {
  const isReadonly = [JobStatus.CLOSED, JobStatus.SUSPENDED].includes(job?.status);

  return (
    <FormCard title="Job Details">
      <div
        style={{ display: 'flex', gap: '20px', justifyContent: 'center', alignItems: 'flex-end' }}
      >
        {/* Keyed by email, not id, so the emitted value stays the recruiterEmail the
            posting-service PATCH expects. */}
        <RecruitersCombobox
          label="Recruiter"
          lang={{ allOptionsText: 'No Recruiter Selected' }}
          keyExtractor={(recruiter) => recruiter.email}
          value={job?.recruiterEmail || ''}
          onChange={({ value }) => handleRecruiterChange('recruiterEmail', value)}
          isReadonly={isReadonly}
        />

        <CustomSelect
          id="status"
          label="Job Status"
          options={jobStatusOptions
            .map((status) => ({
              code: status.code,
              name: status.name,
            }))
            .filter((it) => job?.status === JobStatus.SUSPENDED || it.code !== JobStatus.SUSPENDED)}
          value={job?.status || ''}
          onChange={handleJobStatusChange}
          isReadonly={isReadonly}
        />

        <PlansCombobox label="Plan" isReadonly value={job?.planId} />
      </div>
      <div>
        <InfoRow>
          <span className="semi-bold">Permanent Job ID:</span>
          <span>{job?.id}</span>
        </InfoRow>

        <InfoRow>
          <span className="semi-bold">Office Name:</span>
          {job?.officeId ? (
            <RouteLink to={`/user/dentist/${job?.officeId}`}>{job?.officeName || '-'}</RouteLink>
          ) : (
            <span>-</span>
          )}
        </InfoRow>

        <InfoRow>
          <span className="semi-bold">DSO Name:</span>
          <span>-</span>
        </InfoRow>

        <InfoRow>
          <span className="semi-bold">Created At:</span>
          <span>
            {job?.createdAt ? moment(job.createdAt).format('dddd, MMMM Do, YYYY, h:mm:ss A') : '-'}
          </span>
        </InfoRow>

        <InfoRow>
          <span className="semi-bold">Created By:</span>
          <span>{job?.createdBy || '-'}</span>
        </InfoRow>

        <InfoRow>
          <span className="semi-bold">Updated At:</span>
          <span>
            {job?.updatedAt ? moment(job.updatedAt).format('dddd, MMMM Do, YYYY, h:mm:ss A') : '-'}
          </span>
        </InfoRow>

        <InfoRow>
          <span className="semi-bold">Closed At:</span>
          {job?.closedAt ? moment(job.closedAt).format('dddd, MMMM Do, YYYY, h:mm:ss A') : '-'}
        </InfoRow>

        <InfoRow>
          <span className="semi-bold">Closed By:</span>
          <span>{job?.closedBy || '-'}</span>
        </InfoRow>
      </div>
    </FormCard>
  );
};
